import React from 'react';

import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';

import { BULK_OPERATIONS, BULK_OPERATION_DELETE } from 'components/modules/questions/constants';

import './BulkActions.scss';

const propTypes = {
  onAction: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

const defaultProps = {
  disabled: false,
};

export default function BulkActions({ onAction, disabled }) {
  return (
    <div className="bulk-actions">
      {BULK_OPERATIONS.map((operation) => (
        <Button
          key={operation.key}
          className={operation.key === BULK_OPERATION_DELETE ? 'delete-red' : 'action-button'}
          icon={operation.icon}
          content={operation.text}
          onClick={() => onAction(operation.value)}
          disabled={disabled}
        />
      ))}
    </div>
  );
}

BulkActions.propTypes = propTypes;
BulkActions.defaultProps = defaultProps;
